import type { Room } from '@hollowveil/shared';
import { roomSanctuary } from './sanctuary';
import { roomWonderlandReveil } from './wonderlandReveil';
import { roomHawkinsReveil } from './hawkinsReveil';
import { roomJurassicReveil } from './jurassicReveil';
import { roomWinterfellReveil } from './winterfellReveil';
import { roomMiddleEarthReveil } from './middleEarthReveil';
import { roomFinale } from './finale';

// Export individual rooms
export {
  roomSanctuary,
  roomWonderlandReveil,
  roomHawkinsReveil,
  roomJurassicReveil,
  roomWinterfellReveil,
  roomMiddleEarthReveil,
  roomFinale,
};

// All rooms for the "Le (R)éveil de l'Éducatrice" adventure
// Order is important for progression
export const reveilRooms: Room[] = [
  roomSanctuary,         // Hub - Level 0
  roomWonderlandReveil,  // Level 1 - Le Chapelier qui ne riait plus
  roomHawkinsReveil,     // Level 2 - Vékeuna l'Incompris
  roomJurassicReveil,    // Level 3 - Blue et la Gestion de la Colère
  roomWinterfellReveil,  // Level 4 - Tyrion et l'Estime de Soi
  roomMiddleEarthReveil, // Level 5 - Eärwen, l'Elfe qui Apprenait Autrement
  roomFinale,            // Finale - La Révélation de Benours
];
